var map = {
	"./icon-downcorner.svg": 30901,
	"./icon-inside-2.svg": 89159,
	"./icon-inside.svg": 11406,
	"./icon-yellowcircle.svg": 74690,
	"./illustration-articles.svg": 93820,
	"./illustration-beneficios.svg": 91164,
	"./illustration-ecommerce.svg": 69019,
	"./illustration-goflex.svg": 88422,
	"./reservations.svg": 97967,
	"./reservations_cel.png": 29242,
	"./reservations_home.png": 69569
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86992;